import { render, staticRenderFns } from "./huawei.vue?vue&type=template&id=cc0ad416&scoped=true&"
import script from "./huawei.vue?vue&type=script&lang=js&"
export * from "./huawei.vue?vue&type=script&lang=js&"
import style0 from "./huawei.vue?vue&type=style&index=0&id=cc0ad416&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc0ad416",
  null
  
)

export default component.exports